import { useEffect, useRef, useState } from "react";
import { IoMdAdd } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import loader from "../../../assets/images/loader.gif";
import noimg from "../../../assets/images/noimg.webp";
import Pagination from "../../../components/common/Pagination";
import ListAction from "../../../components/dashboard/admin-dashboard/ListAction";
import TopHeader from "../../../components/dashboard/user-dashboard/TopHeader";
import {
  deletePrduct,
  getUserWiseProduct,
} from "../../../service/DashboardService";
import DoubleConfirm from "../../../components/dashboard/common/DoubleConfirm";
import UpdateProductData from "../../../components/dashboard/user-dashboard/updateData/UpdateProductData";

const UserProductList = () => {
  const navigate = useNavigate();
  const [userProducts, setUserProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const topRef = useRef(null);
  const [deletingProductId, setDeletingProductId] = useState(null);
  const [doubleAlert, setDoubleAlert] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [editProductId, setEditProductId] = useState(null);

  useEffect(() => {
    fetchData();
    scrollToTop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const userId = localStorage.getItem("userId");
      const response = await getUserWiseProduct(userId, token, currentPage, 10);
      setUserProducts(response);
      const totalProjects = response.length;
      const pages = Math.ceil(totalProjects / 10);
      setTotalPages(pages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleDeleteProduct = async (productId) => {
    setDeletingProductId(productId);
    setDoubleAlert(true);
  };

  const confirmDeleteProduct = async () => {
    try {
      await deletePrduct(deletingProductId);
      setUserProducts((prevProducts) =>
        prevProducts.filter(
          (product) => product.ProductId !== deletingProductId
        )
      );
      setDeletingProductId(null);
      setDoubleAlert(false);
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };

  const handleEditProduct = (productId) => {
    setEditProductId(productId); 
    setUpdateModal(true);
  };

  const renderTableRows = () => {
    return userProducts?.map((prod, i) => (
      <tr
        key={i}
        className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
      >
        <td className="px-6 py-4">{prod.ProductName || "NA"}</td>
        <td className="px-6 py-4">
          <img
            src={prod.Image1Main || noimg}
            alt={prod.ProductName || "Product Preview"}
            className="w-20 shadow-md object-cover"
            style={{width:'80px', height:'80px'}}
          />
        </td>
        <td className="px-6 py-4">{prod.PrdtCategory || "NA"}</td>
        <td className="px-6 py-4">
          <ListAction
            isUserDashboard={true}
            onDeleteClick={() => handleDeleteProduct(prod.ProductId)}
            showDeleteButton={true}
            onEditClick={() => handleEditProduct(prod.ProductId)}
          />
        </td>
      </tr>
    ));
  };

  const handlePageChange = (page, e) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const scrollToTop = () => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div ref={topRef}>
        <TopHeader tabName={"Products"} />
        <div className="flex justify-end mb-5">
          <button
            type="button"
            className="flex items-center gap-2 text-gray-900 bg-gradient-to-r from-cyan-200 via-cyan-300 to-cyan-400 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
            onClick={() => navigate("/add-new-product")}
          >
            <IoMdAdd /> Add New Product
          </button>
        </div>

        <div>
          {loading ? (
            <div className="flex justify-center items-center h-screen">
              <img src={loader} alt="Loading" />
            </div>
          ) : (
            <div>
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th scope="col" className="px-6 py-3">
                      Name
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Main Image (Preview)
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Product Category
                    </th>
                    <th scope="col" className="px-2 py-3">
                   
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {userProducts.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center py-4">
                        No records found
                      </td>
                    </tr>
                  ) : (
                    renderTableRows()
                  )}
                </tbody>
              </table>
              {userProducts > 10 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              )}
            </div>
          )}
        </div>
      </div>
      <DoubleConfirm
        open={doubleAlert}
        setOpen={setDoubleAlert}
        onConfirm={confirmDeleteProduct}
      />
      <UpdateProductData open={updateModal} setOpen={setUpdateModal} editProductId={editProductId}/>
    </>
  );
};

export default UserProductList;
